import { render, staticRenderFns } from "./priceRules.vue?vue&type=template&id=267a19aa&scoped=true&"
import script from "./priceRules.vue?vue&type=script&lang=js&"
export * from "./priceRules.vue?vue&type=script&lang=js&"
import style0 from "./priceRules.vue?vue&type=style&index=0&id=267a19aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a19aa",
  null
  
)

export default component.exports